import { Card, Radio, Typography } from "antd"
import VSpace from "../../common/VSpace"
import RadioButton from "../../common/RadioButton"
import { PaymentMethodSummary } from "../../../domain/invoicing/payment"
import { canPaymentMethodBeUsed } from "./payInvoiceModel"
import PaymentMethodDisplay from "../PaymentMethodDisplay"

type Props = {
  paymentMethods: PaymentMethodSummary[]
  selectedPaymentMethodId: string
  onPaymentMethodChange: (paymentMethodId: string) => void
  documentLabel?: string
}

const PaymentMethodsCard = ({ paymentMethods, selectedPaymentMethodId, onPaymentMethodChange, documentLabel = 'Invoice' }: Props) => {
  return <Card
    title={<div style={{ margin: "16px 0" }}>
      Payment Methods
      <br/>
      <Typography.Text type="secondary" style={{fontWeight: 'normal', textWrap: 'wrap'}}>
        Select the payment method you'd like to pay this {documentLabel.toLowerCase()} with.
      </Typography.Text>
    </div>}
  >
    <VSpace size="large">
      <Radio.Group value={selectedPaymentMethodId} onChange={x => onPaymentMethodChange(x.target.value)} style={{ width: '100%' }}>
        <VSpace>
          {paymentMethods.map(x => <RadioButton
            key={x.id}
            value={x.id}
            checked={selectedPaymentMethodId === x.id}
            onBorderClick={() => onPaymentMethodChange(x.id)}
            disabled={!canPaymentMethodBeUsed(x)}
          >
            <PaymentMethodDisplay summary={x} width="650px" />
          </RadioButton>)}
        </VSpace>
      </Radio.Group>
    </VSpace>
  </Card>
}

export default PaymentMethodsCard
